import { render } from "./ReportItem.vue?vue&type=template&id=724dd13c"
import script from "./ReportItem.vue?vue&type=script&lang=js"
export * from "./ReportItem.vue?vue&type=script&lang=js"

import "./ReportItem.vue?vue&type=style&index=0&id=724dd13c&lang=scss"

import exportComponent from "/home/jeim2750/staging.fuelguide.be/front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__